<div id="body">
  <!-- <div class="ib-preview-notice">
    Website preview of unpublished Media Manager images. Layout and CSS are from iBranson; images
    and item details come from the current admin record.
  </div> -->

  <app-ib-header [active]="categoryLabel"></app-ib-header>

  <main role="main">
    <app-ib-hero [src]="heroSrc" [alt]="item.name || 'Item'"></app-ib-hero>

    <div class="show-detail">
      <div class="fixed">
        <app-ib-product-header
          [cover]="cover"
          [item]="item"
          [categoryLabel]="categoryLabel"
          [venueLine]="venueLine"
          [showTimeLabel]="showTimeLabel"
          [activeTab]="activeTab"
          (navigate)="scrollToSection($event.event, $event.tab)"
        ></app-ib-product-header>

        <app-ib-overview [item]="item"></app-ib-overview>

        <app-ib-availability [title]="item.name || 'Item'"></app-ib-availability>

        <app-ib-packages [packages]="packages"></app-ib-packages>

        <app-ib-gallery [title]="item.name || 'Item'" [gallery]="gallery"></app-ib-gallery>

        <app-ib-seat-map [src]="seatMap"></app-ib-seat-map>

        @if (unclassified.length > 0) {
          <app-ib-unclassified [images]="unclassified"></app-ib-unclassified>
        }

        <app-ib-info [item]="item"></app-ib-info>

        <div class="show-detail-down white-block shadow-block margin-block-small">
          <div class="row">
            <div class="col-sm-5 col-lg-6 text-center text-sm-start">
              <h3>
                <b>{{ item.name || 'Untitled item' }}</b>
              </h3>
            </div>
            <div class="col-sm-7 col-lg-6">
              <div class="row">
                <div class="col-7 col-sm-7 col-md-8 col-lg-9 text-start text-sm-end">
                  @if (item.phone) {
                    <small>For more Ticket Info</small>
                    <div class="phone">
                      <span class="icon ib-phone"></span>
                      {{ item.phone }}
                    </div>
                  }
                </div>
                <div class="col-5 col-sm-5 col-md-4 col-lg-3 text-end">
                  <a
                    class="btn btn-primary"
                    href="#availability"
                    (click)="scrollToSection($event, 'availability')"
                    >Buy now</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <app-ib-footer></app-ib-footer>
</div>
